import { IconBed, IconChartDonut, IconMessage } from '@tabler/icons-react'
import { immer } from 'zustand/middleware/immer'

import { AstraIcon } from '~/astra'

import { Slice } from '../store'
import { PageConfigSliceState } from './types'

export const visibilityOptions = {
    showPostOps: 'showPostOps',
    showMetrics: 'showMetrics',
    showComments: 'showComments',
} as const

type VisibilityOptionKeys = keyof typeof visibilityOptions

type State = PageConfigSliceState<VisibilityOptionKeys, ''>

const initialState: State = {
    visibilityOptions: {
        showPostOps: { value: true, label: 'Postoperativ', icon: <AstraIcon icon={IconBed} />, level: 'page' },
        showMetrics: { value: true, label: 'KPI Estimater', icon: <AstraIcon icon={IconChartDonut} />, level: 'item' },
        showComments: { value: true, label: 'Kommentar', icon: <AstraIcon icon={IconMessage} />, level: 'item' },
    },
}

type Actions = {
    actions: {
        toggleVisibility: (optionKey: keyof State['visibilityOptions']) => void
    }
}

export type SurgerySchedulerViewSlice = {
    surgerySchedulerViewOptions: State & Actions
}

export const createSurgerySchedulerViewSlice: Slice<SurgerySchedulerViewSlice> = immer(set => ({
    surgerySchedulerViewOptions: {
        ...initialState,
        actions: {
            toggleVisibility: (optionKey: keyof State['visibilityOptions']) =>
                set(state => {
                    state.surgerySchedulerViewOptions.visibilityOptions[optionKey].value = !state.surgerySchedulerViewOptions.visibilityOptions[optionKey].value
                }),
        },
    },
}))
